import { IUser } from '@giphy/js-types'

export type ZoomMakerError = {
    errorType: string
    message: string
}

export enum ZoomMakerStatus {
    Idle = 'IDLE',
    Downloading = 'DOWNLOADING',
    Uploading = 'UPLOADING',
    Creating = 'CREATING',
    Complete = 'COMPLETE',
}

export type ZoomMakerFile = {
    file: File | string
    fileType: string
    height?: number
    id: string
    preview: string
    urlType?: string
    sourceUrl?: string
    videoEmbed?: string
    type: string
    width?: number
    isStarter?: boolean
}

export type ZoomMakerProps = {
    apiKey: string
    user: IUser
    submitUrl: string
    featuredStickers?: string[]
    updateCreationTool: (props: any) => void
    clearError: () => void
    setCreationUploadInfo: (info: any) => void
    resetCreationTool: () => void
    setCurrentFilter: (filter: any) => void
    setCreationLocation: (type: string) => void
}

export type ZoomMakerFrame = {
    data: ImageData
    delay: number
}
